import { IApplicationState } from '../../types/redux';
import { getNewBuildingById } from './getNewBuildingById';

export function getNewBuildingLabels(state: IApplicationState, newBuildingId: number) {
  const newBuilding = getNewBuildingById(state, newBuildingId);

  return newBuilding.labels;
}
